<template>
  <div>
    <div class="pagelist animate fadeIn">
      <div class="container">
        <div class="header-pagelist">
          <h1 class="header-title text-center">โอกาสพิเศษที่อยากให้คุณมีส่วนร่วม</h1>
          <h2 class="sub-title ma-0 text-center">ร่วมบริจาคในโอกาสพิเศษและให้โอกาสทางการศึกษาแก่เด็กด้อยโอกาสไปพร้อมกัน</h2>
          <router-link tag="button" :to="`special-events/pages/create`" type="button" class="ma-auto btn btn--white">บริจาคในโอกาสพิเศษของคุณ</router-link>
        </div>
      </div>


      <div class="container">
        <div class="row">
          <div class="col col-sm-4 flex" v-for="item in items" :key="item.id">
            <div class="shadow card" :class="getCardClasses(item)">
              <div class="card-header" :style="getCardStyle(item)">
                <router-link :to="`/pages/${item.id}`" @click.prevent="goToPage(item)">
                  <div class="img-circle" :style="{backgroundImage: `url('${item.image}')`}"></div></router-link>
                <h2 class="card-title" v-if="item.data.type === $const.SPECIAL_EVENT_TYPES.BIRTHDAY">Happy Birthday</h2>
                <h2 class="card-title" v-if="item.data.type === $const.SPECIAL_EVENT_TYPES.ANNIVERSARY">Happy Anniversary</h2>
                <h2 class="card-title" v-if="item.data.type === $const.SPECIAL_EVENT_TYPES.OTHER">{{ item.data.custom_type }}</h2>
                <div>{{ item.data.name }}<br />{{ getFormattedDate(item) }}</div>
              </div>
              <div class="card-body" v-if="item.data.message">
                {{ item.data.message }}
              </div>
              <div class="card-footer">
                <funding-goal
                  class="mb-20"
                  ref="fundingGoal"
                  :target="getDonationTarget(item)"
                  :amount="getDonationAmount(item)"
                  :end-date="item.data.end_date"
                  :percent="getDonationProgress(item)"/>
                <router-link tag="button" :to="`/pages/${item.id}`" type="button" class="ma-auto btn btn--default btn--full" @click.prevent="goToPage(item)">ร่วมบริจาค</router-link>
              </div>
            </div>
          </div>
        </div>

        <loader v-if="loading" />
        <div class="w-50 ma-auto mt-15 mb-15" v-if="loaded && error && !loading && false">
          <p class="text-center">ไม่พบข้อมูล</p>
          <a href="#" class="btn btn--white" @click.prevent="refresh">โหลดใหม่อีกครั้ง</a>
        </div>
        <div class="w-50 ma-auto mt-15 mb-15">
          <a class="btn btn--white" href="#" @click.prevent="loadMore" v-if="showLoadMore && items.length > 0">ดูเพิ่ม</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FundingGoal from '@/components/FundingGoal'
  import Loader from '@/components/Loader'

  export default {
    name: 'ProductSpecialEvents',

    components: {
      FundingGoal,
      Loader
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        loaded: false,
        loading: false,
        error: false,
        showLoadMore: false,
        offset: 0,
        ipp: 12,
        items: []
      }
    },

    computed: {
      params () {
        return {
          offset: this.offset,
          ipp: this.ipp,
          ref_obj_type: 'product',
          ref_obj_id: this.product.id,
          data: JSON.stringify({
            total_product_quantity: `0,gt`
          })
        }
      }
    },

    created () {
      this.fetch(this.params, true)
    },

    methods: {
      fetch (params, clearItems) {
        this.loading = true
        this.error = false

        this.$http.get(`pages`, { params: params }).then(resp => {
          this.loaded = true
          this.loading = false

          if (clearItems) {
            this.items = []
          }

          const items = resp.body.pages
          items.forEach(item => {
            try {
              item.data = JSON.parse(item.data)
            } catch (err) {
              item.data = {}
            }
            if (!item.data.total_product_price) {
              item.data.total_product_price = 0
            }
            if (!item.data.total_product_quantity) {
              item.data.total_product_quantity = 0
            }
            if (!item.data.target) {
              item.data.target = 0
            }
            if (!item.image) {
              item.image = `/static/img/image-preset-event/default-avatar.jpg`
            }
            this.items.push(item)
          })

          this.pager = resp.body.pager
          const numItems = this.offset + this.ipp
          const total = this.pager.total || 0
          this.showLoadMore = numItems < total
        }).catch(e => {
          console.log(e)
          this.loaded = true
          this.loading = false
          this.error = true
        })
      },

      loadMore () {
        this.offset += this.ipp
        this.showLoadMore = false
        this.loading = true

        setTimeout(() => {
          this.fetch(this.params)
        }, 300)
      },

      goToPage (item) {
        this.$router.push(`/pages/${item.id}`)
      },

      getFormattedDate (item) {
        const month = this.$const.MONTH_LIST.find(m => m.value === item.data.month)
        if (month) {
          return `${parseInt(item.data.day)} ${month.name}`
        }
        return '-'
      },

      getDonationProgress (item) {
        const progress = Math.floor((this.getDonationAmount(item) / this.getDonationTarget(item)) * 100)
        if (!isNaN(progress)) {
          return progress
        }
        return 0
      },

      getDonationAmount (item) {
        return item.data.total_product_price || 0
      },

      getDonationTarget (item) {
        const target = parseInt(item.data.target)
        if (!isNaN(target)) {
          return target
        }
        return 0
      },

      getBackgroundImageUrl (item) {
        let filename = 'preset-01.jpg'
        if (item.data.bottom_image) {
          const paths = item.data.bottom_image.split('/')
          const last = paths[paths.length - 1]
          if (last.length > 0 && last.endsWith('.jpg')) {
            filename = last
          }
        }
        return `/static/img/image-preset-event/bg-${filename}`
      },

      getCardStyle (item) {
        return {
          backgroundImage: `url("${this.getBackgroundImageUrl(item)}")`
        }
      },

      getCardClasses (item) {
        const classes = {}
        classes[`t-daytype-${item.data.type}`] = true
        return classes
      }
    }
  }
</script>

<style scoped lang="scss">
  .pagelist {
    background: #F2F2F4 url("../../../assets/img/bg-grey_hex.png") no-repeat top center;
    background-size: 100%;
    @media all and (max-width: 767px) {
      .container {
        max-width: 360px;
      }
    }

    .row {
      display: flex;
      display: -webkit-flex;
      flex-wrap: wrap;
      flex-wrap: -webkit-flex-wrap;
    }

    .header-pagelist {
      padding: 1em 0 1.5em;
      h1,h2 { color: #242424 }
    }

    .card {
      background: #fff;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      -webkit-flex-direction: column;
      flex: 1;
    }

    .card-header {
      background: #fff url("/static/img/image-preset-event/bg-preset-03@2x.png") no-repeat top center;
      background-size: cover;
      text-align: center;
      padding: 1em;
      color: #242424;
      .card-title {
        font-family: mitr, sans-serif;
        color: #242424;
        text-shadow: 1px 2px 2px #00000047;
        font-weight: 500;
        font-size: 20px;
        margin-bottom: 0.5em;
        @media all and (min-width: 1023px) {
          font-size: 23px;
        }
      }
    }
    .img-circle {
      display: inline-block;
      border-radius: 50%;
      width: 170px;
      height: 170px;
      border: 5px solid #fff;
      margin-bottom: 1em;
      box-sizing: border-box;
      background-position: center center;
      background-size: cover
    }

    .card-body {
      background: #fff;
      padding: 1em;
      border-bottom: 1px solid #C7D2D7;
      font-size: 15px;
      line-height: 1.4em;
      @media all and (min-width: 1023px) {
        font-size: 17px;
      }
    }

    .card-footer {
      background: #fff;
      padding: 1em;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      -webkit-flex-direction: column;
      justify-content: flex-end;
      -webkit-justify-content: flex-end;
      flex: 1 0 auto;
    }

    /* Birthday Type */
    .t-daytype-1 {
      .card-header {
        color: #fff;
        .card-title { color: #fff; }
      }
    }
    /* วันสำคัญ Type */
    .t-daytype-3 {
      .card-header {
        color: #242424;
        .card-title { color: #242424; }
      }
    }

  }
  .header-pagelist {
    .btn {
      font-size: 1em;
      margin: 1em auto 0;
      border-radius: 15px;
      padding: 5px 15px;
      min-height: 45px;
      height: 45px;
    }
  }

</style>



// WEBPACK FOOTER //
// special-events.vue?e3c91fb6